import { Entry } from '../Entry'

export function Entry20230809() {
  return (
    <Entry title="Aug 09 2023 - v3.4.10">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13947/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
